<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center">
    <div class="text-center">
      <div v-if="error" class="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full mx-4">
        <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2 class="text-lg font-semibold text-gray-900 mb-2">ログイン失敗</h2>
        <p class="text-sm text-gray-500 mb-6">{{ error }}</p>
        <button
          class="w-full bg-blue-600 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-blue-700 transition-colors"
          @click="$router.push('/')"
        >
          トップページへ戻る
        </button>
      </div>
      <div v-else class="flex flex-col items-center gap-4">
        <div class="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        <p class="text-sm text-gray-500">GitLab 認証中...</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { exchangeOAuthCode } from '../api.js';

const router = useRouter();
const error = ref('');

onMounted(async () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const errorParam = params.get('error');

  if (errorParam) {
    error.value = `GitLab が認証を拒否しました: ${errorParam}`;
    return;
  }

  if (!code) {
    error.value = '認証コードが見つかりません。';
    return;
  }

  try {
    const redirectUri = `${window.location.origin}/auth/callback`;
    const { sessionToken, user } = await exchangeOAuthCode(code, redirectUri);

    localStorage.setItem('sessionToken', sessionToken);
    localStorage.setItem('currentUser', JSON.stringify(user));

    router.replace('/');
  } catch (err) {
    error.value = err.message || '認証に失敗しました。';
  }
});
</script>
